export const indicatorsTemp = [
  {
    name: 'Cortisol',
    description: 'Test test tes tse t set ',
    url: 'cortisol',
    _id: 1,
    subjectIds: [1, 2, 3],
    scaleType: 'RAGAG',
    unitType: 'cells/L',
    creator: 100,
  },
  {
    name: 'Thyroid Hormones',
    description: 'Test test tes tse t set ',
    url: 'thyroid-hormones',
    _id: 2,
    subjectIds: [1, 2, 3],
    scaleType: 'RAG',
    unitType: 'cells/L',
    creator: 100,
  },
  {
    name: 'Insulin',
    description: 'Test test tes tse t set ',
    url: 'insulin',
    _id: 3,
    subjectIds: [1],
    scaleType: 'RAGAG',
    unitType: 'cells/L',
    creator: 101,
  },
]

export const interpretationsTemp = [
  {
    name: 'Test Deases',
    description: 'Deases description',
    url: 'test-deases',
    _id: 1,
    recomendationIds: [1, 2, 3],
    signalIds: [1, 2, 3],
    creator: 100,
  },
]

export const recommendationsTemp = [
  {
    name: 'Eat great food',
    description: 'Test test tes tse t set ',
    url: 'eat-great-food',
    _id: 1,
    interpretattionIds: [1, 2, 3],
    creator: 100,
  },
]

export const signalsTemp = [
  {
    name: 'Cortisol',
    url: 'cortisol',
    _id: 1,
    subjectIds: [1, 2, 3],
    indicatorIds: [2, 3, 4],
    intereationsIds: [1, 2, 3],
    creator: 100,
  },
  {
    name: 'Thyroid Hormones',
    url: 'thyroid-hormones',
    _id: 2,
    subjectIds: [1, 2, 3],
    indicatorIds: [2, 3, 4],
    intereationsIds: [1, 2, 3],
    subjectId: 1,
    creator: 100,
  },
]

export const subjectsTemp = [
  {
    name: 'Endocryne System',
    url: 'endocryne-system',
    _id: 1,
    creator: 100,
  },
  {
    name: 'Nervous System',
    url: 'nervous-system',
    _id: 2,
    creator: 100,
  },
  {
    name: 'Digestive System',
    url: 'digestive-system',
    _id: 3,
    creator: 100,
  },
  {
    name: 'Circulatory System',
    url: 'circulatory-system',
    _id: 4,
    creator: 100,
  },
  {
    name: 'Respiratory System',
    url: 'respiratory-system',
    _id: 5,
    creator: 100,
  },
  {
    name: 'Muscular System',
    url: 'muscular-system',
    _id: 6,
    creator: 101,
  },
  {
    name: 'Skeletal System',
    url: 'skeletal-system',
    _id: 7,
    creator: 104,
  },
  {
    name: 'Reproductive System',
    url: 'reproductive-system',
    _id: 8,
  },
]

export const userTemp = {
  firstName: 'Joshua',
  auth: true,
  secondName: 'Walker',
  email: 'test@test.com',
  id: 1,
  img: 'https://img.freepik.com/premium-photo/close-up-young-successful-man-smiling-front-standing-casual-outfit-against-blue-wall_1258-43431.jpg',
}

export const IndicatorsSignalTemp = [
  {
    id: Math.round(Math.random() * 1000),
    name: 'sfdskfdsklnfdskfndslkf',
    author: 'kdsaflkdmsalfkmdsaf',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'fkdslanfkdasnfkldasf',
    author: 'skflnakdfalfadklfnda',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'dksanfklasdnfklafas',
        author: 'aksdnfkdasnlkfdklasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'kdsafnldsafklsadflasf',
    author: 'afklsamfklklasfka',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'lfmsalkfmalskfklanfklmaskfma',
        author: 'skdafkldsnakflsamflkasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'sfdskfdsklnfdskfndslkf',
    author: 'kdsaflkdmsalfkmdsaf',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'fkdslanfkdasnfkldasf',
    author: 'skflnakdfalfadklfnda',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'dksanfklasdnfklafas',
        author: 'aksdnfkdasnlkfdklasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'kdsafnldsafklsadflasf',
    author: 'afklsamfklklasfka',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'lfmsalkfmalskfklanfklmaskfma',
        author: 'skdafkldsnakflsamflkasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'sfdskfdsklnfdskfndslkf',
    author: 'kdsaflkdmsalfkmdsaf',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'fkdslanfkdasnfkldasf',
    author: 'skflnakdfalfadklfnda',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'dksanfklasdnfklafas',
        author: 'aksdnfkdasnlkfdklasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'kdsafnldsafklsadflasf',
    author: 'afklsamfklklasfka',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'lfmsalkfmalskfklanfklmaskfma',
        author: 'skdafkldsnakflsamflkasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'sfdskfdsklnfdskfndslkf',
    author: 'kdsaflkdmsalfkmdsaf',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
      {
        id: Math.round(Math.random() * 1000),
        name: 'sdkfmdksfldsmakjndfkasfads',
        author: 'dsafknklasnfkladslfa',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'fkdslanfkdasnfkldasf',
    author: 'skflnakdfalfadklfnda',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'dksanfklasdnfklafas',
        author: 'aksdnfkdasnlkfdklasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
  {
    id: Math.round(Math.random() * 1000),
    name: 'kdsafnldsafklsadflasf',
    author: 'afklsamfklklasfka',
    valueLevels: [
      { color: 'red', value: 150 },
      { color: 'green', value: 300 },
    ],
    unit: 'sad',
    children: [
      {
        id: Math.round(Math.random() * 1000),
        name: 'lfmsalkfmalskfklanfklmaskfma',
        author: 'skdafkldsnakflsamflkasf',
        valueLevels: [
          { color: 'red', value: 150 },
          { color: 'green', value: 300 },
        ],
      },
    ],
  },
]
